document.addEventListener('DOMContentLoaded', function () {
  const gateCard = document.getElementById('gate-card');

  // If gate card doesn't exist, user is already verified via Liquid
  // Just ensure body is visible and exit
  if (!gateCard) {
    document.body.style.opacity = '1';
    return;
  }

  const pinForm = document.getElementById('pin-form');
  const accessGateSection = document.getElementById('access-gate-wrapper');
  const successMessage = document.getElementById('success-message');
  const pinInput = document.getElementById('pin-code');
  const errorMsg = document.getElementById('pin-error');

  // Fade-in body early for smoother UX (only if not already set)
  try {
    // Ensure we have a visible transition for opacity (non-zero duration)
    const opacityTransition = 'opacity 300ms ease-in-out';
    if (!document.body.style.transition || !document.body.style.transition.includes('opacity')) {
      // preserve any existing transitions and add opacity
      const existing = document.body.style.transition && document.body.style.transition.trim() !== '' ? document.body.style.transition + ', ' + opacityTransition : opacityTransition;
      document.body.style.transition = existing;
    }
    if (!document.body.style.opacity) document.body.style.opacity = '0';
  } catch (e) { }

  // Get settings from data attributes
  // We removed specialParam logic.
  // We treat the gate as always active (pincode only mode).
  const correctPin = gateCard.dataset.pin || '';

  // Check if user has already verified (check cart attribute)
  // This is a fallback check - Liquid should handle most cases
  checkAccessVerification().then(isVerified => {
    if (isVerified) {
      // User already verified, bypass gate
      bypassGate();
      return;
    }

    // User not verified, show the gate
    // Force a reflow so the browser registers the starting opacity before we transition to 1
    void document.body.offsetWidth;
    setTimeout(() => { document.body.style.opacity = '1'; }, 100);

    if (accessGateSection) accessGateSection.classList.add('show');
    document.body.classList.add('gate-active');

    setTimeout(() => {
      if (pinInput) pinInput.focus();
    }, 300);
  });

  if (!pinForm) return;

  pinForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const enteredPin = pinInput ? pinInput.value : '';

    if (enteredPin === correctPin) {
      if (successMessage) successMessage.classList.add('show');
      if (accessGateSection) accessGateSection.classList.add('hidden');

      // Set cart attribute to remember verification
      setAccessVerification().then(() => {
        setTimeout(() => {
          if (accessGateSection) accessGateSection.classList.add('removed');
          document.body.classList.remove('gate-active');
          if (successMessage) setTimeout(() => successMessage.classList.remove('show'), 1000);
          // If a redirect URL is supplied on the card, use it; otherwise just remove gate
          const redirectUrl = gateCard.dataset.redirectUrl || null;
          if (redirectUrl) window.location.href = redirectUrl;
        }, 500);
      });
      return;
    }

    if (errorMsg) errorMsg.classList.add('show');
    if (pinInput) {
      pinInput.value = '';
      pinInput.focus();
      pinInput.classList.add('border-red-500');
    }

    setTimeout(() => {
      if (errorMsg) errorMsg.classList.remove('show');
      if (pinInput) pinInput.classList.remove('border-red-500');
    }, 3000);
  });

  if (pinInput) {
    pinInput.addEventListener('input', function () {
      if (errorMsg) errorMsg.classList.remove('show');
    });

    pinInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        pinForm.dispatchEvent(new Event('submit'));
      }
    });
  }

  // Helper function to bypass gate (already verified)
  function bypassGate() {
    void document.body.offsetWidth;
    setTimeout(() => { document.body.style.opacity = '1'; }, 100);
    if (accessGateSection) {
      accessGateSection.classList.remove('show');
      accessGateSection.classList.add('removed');
    }
    document.body.classList.remove('gate-active');
  }

  // Helper function to check if user has already verified
  async function checkAccessVerification() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return false;
      const cart = await response.json();
      return cart.attributes && cart.attributes.access_verified === 'true';
    } catch (error) {
      console.error('Error checking access verification:', error);
      return false;
    }
  }

  // Helper function to set cart attribute when user verifies
  async function setAccessVerification() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            access_verified: 'true'
          }
        })
      });
      if (!response.ok) {
        console.error('Failed to set access verification');
      }
    } catch (error) {
      console.error('Error setting access verification:', error);
    }
  }
});  